import React from "react";
import GenericOrdersListing from "@Pages/OrderListing/GenericOrdersListing.js";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import ChatPopup from "@Pages/GenericOrderChat/ChatPopup.jsx";
import { InsertDocumentPopup } from "../../Documents/InsertDocumentPopup.js";

function Form4StarredOrdersListing() {
  return (
    <GenericOrdersListing
      title="Starred Orders"
      isReleased={false}
      isCanceled={false}
      readOnly={false}
      icon={AssignmentRoundedIcon}
      ChatPopup={ChatPopup}
      InsertDocumentPopup={InsertDocumentPopup}
      showAddDocument={true}
      isStarred={true}
    />
  );
}

export default Form4StarredOrdersListing;
